import '../styles/splash.css';
import { HOME_CHANNEL_ID, indexOfId } from '../channels/registry.js';

const PHASE_OSD_MS = 1600;
const PHASE_TITLE_MS = 2800;
const FADE_MS = 480;

/**
 * VCR power-on intro. Resolves with the home channel id when finished.
 * Skipped when session already saw splash this tab, or path is a deep link.
 */
export function runSplash(root) {
  const deep = location.pathname.split('/').filter(Boolean).length > 0;
  const seen = sessionStorage.getItem('nt-splash-done') === '1';
  if (deep || seen) {
    return Promise.resolve(null);
  }

  return new Promise((resolve) => {
    document.body.classList.add('intro-body');
    root.innerHTML = `
      <div id="intro" class="intro" aria-label="Noise Table intro">
        <div class="intro__grain" aria-hidden="true"></div>
        <div class="intro__vignette" aria-hidden="true"></div>
        <div class="intro__phase intro__phase--osd" id="intro-osd">
          <header class="intro__header">
            <span class="intro__play" id="intro-play">PLAY</span>
            <span class="intro__clock" id="intro-clock">--:--</span>
          </header>
        </div>
        <div class="intro__phase intro__phase--title" id="intro-title" aria-hidden="true">
          <div class="intro__brand-wrap">
            <p class="intro__brand">▲ NOISE TABLE ▲</p>
          </div>
        </div>
        <p class="intro__advisory" role="note">
          <span class="intro__advisory-label">Advisory</span>
          Some channels use flashing lights and rapid color
          changes that may be uncomfortable for photosensitive or visually sensitive
          viewers.
        </p>
      </div>`;

    const rootEl = root.querySelector('#intro');
    const osdEl = root.querySelector('#intro-osd');
    const titleEl = root.querySelector('#intro-title');
    const playEl = root.querySelector('#intro-play');
    const clockEl = root.querySelector('#intro-clock');
    const brandEl = root.querySelector('.intro__brand');

    let secs = 0;
    playEl.classList.add('blink');
    const tick = setInterval(() => {
      secs += 1;
      const m = Math.floor(secs / 60);
      const s = secs % 60;
      clockEl.textContent = `${m}:${String(s).padStart(2, '0')}`;
    }, 1000);

    function trackingTear() {
      const bar = document.createElement('div');
      bar.className = 'intro__tracking-bar';
      bar.setAttribute('aria-hidden', 'true');
      rootEl.appendChild(bar);
      bar.addEventListener('animationend', () => bar.remove(), { once: true });
    }

    setTimeout(() => {
      osdEl.classList.add('is-out');
      osdEl.setAttribute('aria-hidden', 'true');
      titleEl.classList.add('is-active');
      titleEl.setAttribute('aria-hidden', 'false');
      playEl.classList.remove('blink');
      trackingTear();
      requestAnimationFrame(() => brandEl.classList.add('is-rising'));
      clearInterval(tick);
    }, PHASE_OSD_MS);

    setTimeout(() => {
      clearInterval(tick);
      sessionStorage.setItem('nt-splash-done', '1');
      sessionStorage.setItem('nt-ch', String(indexOfId(HOME_CHANNEL_ID)));
      document.body.classList.add('is-exiting');
      rootEl.classList.add('off');
      setTimeout(() => {
        document.body.classList.remove('intro-body', 'is-exiting');
        root.innerHTML = '';
        resolve(HOME_CHANNEL_ID);
      }, FADE_MS);
    }, PHASE_OSD_MS + PHASE_TITLE_MS);
  });
}
